import { cn } from "@/lib/utils";

export default function GlassCard({ children, className, glow, onClick, testId, ...props }) {
  return (
    <div
      data-testid={testId}
      onClick={onClick}
      className={cn(
        "bg-white/5 backdrop-blur-xl border border-white/10 rounded-2xl p-6 transition-all duration-300 hover:border-white/20",
        glow && "shadow-[0_0_20px_rgba(0,242,96,0.1)]",
        onClick && "cursor-pointer hover:scale-[1.01]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  );
}
